<template>
  <div class="rich-body">
    <div class="rich-text-editor">
      <!-- 富文本编辑器 -->
      <div class="editor">
        <div id="editor—wrapper">
          <div id="toolbar-container"><!-- 工具栏 --></div>
          <div id="editor-container"><!-- 编辑器 --></div>
        </div>
      </div>

      <!-- 实时预览 -->
      <div class="preview" v-html="localContent" />
    </div>
    <div class="content">
      <el-input resize="none" v-model="localContent" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" />
    </div>
  </div>
</template>

<script>
import debounce from '@/utils/debounce.js'
import set from '@/javaApi/set'

const setModel = new set()
let editor = null
let toolBar = null

export default {
  name: 'RichTextEditor',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localContent: this.value,
      editor: null,
      toolbar: null,
    }
  },
  watch: {
    value(val) {
      if (val !== this.localContent) {
        this.localContent = val
      }
    },
    localContent(val) {
      this.$emit('input', val)
      debounce(()=>{
        editor.setHtml(val)
      },500)
    }
  },
  methods: {
    // 自定义图片上传函数，调用你的接口
    async uploadImage(file, insertFn) {
      const formData = new FormData()
      formData.append('file', file)
      const res = await setModel.uoloadFile2(formData)

      if (!res.data.success) {
        this.$message.error(res.data.message)
        return;
      }
      insertFn(res.data.data, '', '')
    },
    handleChange(editor){
      this.localContent = editor.getHtml()
    },
  },
  mounted() {
    const { createEditor, createToolbar } = window.wangEditor
    const editorConfig = {
      placeholder: '请输入富文本内容',
      onChange: this.handleChange,
      MENU_CONF:{}
    }

    editorConfig.MENU_CONF['uploadImage'] = {
      // 自定义上传
      customUpload: this.uploadImage
    }

    console.log('---------------------------------------------------------------')

    console.log(this.value)

    editor = createEditor({
      selector: '#editor-container',
      html: this.value,
      config: editorConfig,
      mode: 'default',
    })

    const toolbarConfig = {}
    toolBar = createToolbar({
      editor,
      selector: '#toolbar-container',
      config: toolbarConfig,
      mode: 'default', // or 'simple'
    })
  }
}
</script>

<style scoped>

.rich-body{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rich-text-editor {
  display: flex;
  gap: 20px;
  min-height: 300px;
}

.editor{
  flex: 1;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.preview {
  flex: 1;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/richText.vue